import { createFileRoute } from '@tanstack/react-router';
import { AirtableCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/airtable/callback')({
  component: AirtableCallbackPage,
});
